/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PracticeHubAccountStatus/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Active from './Active/index'
import Inactive from './Inactive/index'
import No from './No/index'
import NotInvited from './NotInvited/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2UserHomeSingle from 'DesignSystem/Svgs/Tysiav2UserHomeSingle/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PracticeHubAccountStatus({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content/PracticeHubAccountStatus",
  flexBasis = "33%"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let patientPersonPublicUserValueData = fromData.useDataFormat({ viewPath,
context: 'patient',
path: 'person.public_user',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: patientPersonPublicUserValueData,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="PracticeHubAccountStatus.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="PracticeHubAccountStatus.Horizontal:1"
  data-view-path={viewPath}
 style={{'--fb-1-Z1hG1s6': typeof flexBasis === 'number' ? `${flexBasis}%` : flexBasis,'--g-2-Z1hG1s6': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Tysiav2UserHomeSingle
  viewPath={`${viewPath}/Tysiav2UserHomeSingle`}
 fill2={dtColorsNeutral400}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 text="Practice Hub"
/>
</div>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Active'}>
<Active
  viewPath={`${viewPath}/Active`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Inactive'}>
<Inactive
  viewPath={`${viewPath}/Inactive`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NotInvited'}>
<NotInvited
  viewPath={`${viewPath}/NotInvited`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}